export const environment = {
  production: true,
  name: 'STARFIN',
  group: 'STARFIN',
  hostUrl: `https://client.gateway.starfin.com.ua/v1/api/rest`,
  isTestPaymentEnabled: false,
  isInnValidationEnabled: true,
  recaptchaKEY_CODE: '6LdYHAkqAAAAAJKi4iCaOBzoQNYUvPJDf6EaIQIC',
  cookieDomain: '.starfin.com.ua',
  WEBSITE_URL: 'https://starfin.com.ua/',
  LOGO_SITE: '../assets/images/logo.svg',
  LOGO_WHITE: '../assets/images/logo.svg',
  PHONES: [
    {
      label: '0 800 202 233',
      contact: 'tel:0800202233',
      type: 'CONTACTS.PHONES.PHONE_UA',
    },
    {
      label: '+38(063) 020 22 33',
      contact: 'tel:+380630202233',
      type: 'CONTACTS.PHONES.PHONE_UA_NOT_FREE',
    },
  ],
  EMAILS: [
    {
      label: 'info@starfin.com.ua',
      contact: 'mailto:info@starfin.com.ua',
    },
  ],
  GA_TAG: '2ZF3VH9DZ5',
  partnerLink: 'https://groshi.bez-otkazov.com/?utm_source=star&utm_medium=refferal&utm_campaign=lk&utm_term=',
  homeLink: 'https://starfin.com.ua/auth/login',
  showPhone: false,
  smsViber: false,
  showIVR: true,
  helpCranchKey: '52a13ca2-1812-4237-b0e1-27c192c18ebe',
  helpCranchOrganization: 'starfin',
  gtmId: 'GTM-MV4JLB2',
  initSeon: true,
  initRecaptcha: false,
  publicDocumentsUrl: 'https://public-document.starfin.com.ua/',
};
